import { render, staticRenderFns } from "./drawerData.vue?vue&type=template&id=0a81db1a"
import script from "./drawerData.vue?vue&type=script&lang=js"
export * from "./drawerData.vue?vue&type=script&lang=js"
import style0 from "./drawerData.vue?vue&type=style&index=0&id=0a81db1a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a81db1a')) {
      api.createRecord('0a81db1a', component.options)
    } else {
      api.reload('0a81db1a', component.options)
    }
    module.hot.accept("./drawerData.vue?vue&type=template&id=0a81db1a", function () {
      api.rerender('0a81db1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/ProfileTemplates/components/drawerData.vue"
export default component.exports